<h2 mat-dialog-title>Asignar correo</h2>

<form [formGroup]="correoForm" (ngSubmit)="guardar()" autocomplete="off">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Correo electrónico</mat-label>
      <input matInput formControlName="correo" type="email" />
      <mat-error *ngIf="correoForm.get('correo')?.hasError('required')">
        El correo es obligatorio.
      </mat-error>
      <mat-error *ngIf="correoForm.get('correo')?.hasError('email')">
        Correo no válido.
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button-cancel-dialog></app-button-cancel-dialog>

    <app-button-save [isDialogClose]="true"></app-button-save>
  </mat-dialog-actions>
</form>
